/*
	Swiper's accessibility module labels its arrows and pagination bullets in
	English ("Previous slide", "Next slide", "Go to slide 1"). Every slider on the
	site is created with `new Swiper(...)`, so instead of editing each one this
	wraps the constructor once and fills in the translated labels from
	window.theme.a11y (set in layout/theme.liquid). A slider that passes its own
	a11y options keeps them.
*/
(function () {
	var Original = window.Swiper;
	var labels = window.theme && window.theme.a11y;
	if (!Original || !labels || Original.__a11yTranslated) return;

	var messages = {
		prevSlideMessage: labels.previous,
		nextSlideMessage: labels.next,
		firstSlideMessage: labels.first,
		lastSlideMessage: labels.last,
		// theme.liquid passes __INDEX__ because "}}" cannot sit inside a Liquid string;
		// Swiper's own placeholder is {{index}}.
		paginationBulletMessage: String(labels.goTo || '').replace('__INDEX__', '{{index}}'),
	};

	function TranslatedSwiper(container, params) {
		var options = params || {};
		var a11y = options.a11y;
		if (a11y !== false) {
			options.a11y = Object.assign({}, messages, a11y === true ? {} : a11y);
		}
		return new Original(container, options);
	}

	// Keep static members (Swiper.use, Swiper.defaults, ...) and instanceof working.
	Object.setPrototypeOf(TranslatedSwiper, Original);
	TranslatedSwiper.prototype = Original.prototype;
	TranslatedSwiper.__a11yTranslated = true;

	window.Swiper = TranslatedSwiper;
})();
